import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SquareBox extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    header: PropTypes.node,
    body: PropTypes.node,
    footer: PropTypes.node,
  };

  render() {
    const { className, header, body, footer } = this.props;
    return (
      <div className={classnames('square-box', className)}>
        <div className="square-box__header">{header}</div>
        <div className="square-box__body">{body}</div>
        {footer ? <div className="square-box__footer">{footer}</div> : null}
      </div>
    );
  }
}

export default SquareBox;
